<div class="add-providers">
  <span class="caption">Add providers to this office:</span>

  <form #formDirective="ngForm" [formGroup]="formGroup" (submit)="onSubmit()">

    <ng-container formArrayName="providerOffices">
      @for (providerOfficeForm of providerOfficeFormArray.controls; track providerOfficeForm; let i = $index) {
        <div class="row">
          <div class="col-11">
            <app-office-provider-new-row
              [formArrayIndex]="i"
              [rowForm]="providerOfficeFormByIndex(i)"
              [existingProviderOffices]="providerOffices" />
          </div>
          <div class="col-1">
            @if (providerOfficeFormArray.length > 1) {
              <a href="#"
                class="delete-new-provider-office"
                (click)="onDeleteNewProviderOfficeClick($event, i)">
                <fa-icon [icon]="['fas', 'trash']" size="1x" />
              </a>
            }
          </div>
        </div>
      }
    </ng-container>

    <div class="row">
      <div class="col-12">
        <a href="#" (click)="onAddNewProviderOfficeClick($event)">
          <fa-icon [icon]="['fas', 'plus-circle']" />
          Add Another Provider
        </a>
      </div>
    </div>

    <div class="row">
      <div class="col-11 new-provider-actions">
        <button
          class="btn btn-secondary"
          (click)="onCancelClick()">
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary">
          Save
        </button>
      </div>
      <div class="col-1">
      </div>
    </div>

  </form>
  <hr />
</div>
